<template>
    <ChangePassword/>
</template>
<script>
import ChangePassword from '../components/security/ChangePassword.vue'
export default {
    components:{
        ChangePassword
    }
};
</script>